import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { db } from "firebase/fbConfig.js"
// Tola Add -Ons
import { Link } from "react-router-dom";
import Switch from "@material-ui/core/Switch";
import loader from "assets/img/loader.gif";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ArchiveIcon from '@material-ui/icons/Archive';
import CallIcon from '@material-ui/icons/Call';
import InfoIcon from '@material-ui/icons/Info';
import AssignmentIcon from '@material-ui/icons/Assignment';
import LockIcon from '@material-ui/icons/Lock';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import FaceIcon from '@material-ui/icons/Face';

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";


// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Table from "components/Table/Table.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Search from "@material-ui/icons/Search";
import Accordion from "components/Accordion/Accordion.jsx";
import NavPills from "components/NavPills/NavPills.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import Style from "assets/jss/material-dashboard-pro-react/views/SettingsStyle";
import { Grid } from "@material-ui/core";
import marc from "assets/img/faces/marc.jpg";
import avatar from "assets/img/faces/avatar.jpg";

// Forms
import AssignActionForm from "components/Forms/AssignActionForm.jsx"

// Firebase Redux Integration
import { startSetPendingActionsList } from 'store/actions/actionsActions'
import { tableToFirestoreObjects, updateFirestoreWithTableData, addFieldToDocument } from "store/actions/firestoreActions"
import { startSetUsersList } from "store/actions/adminActions"

import { startLogout } from "../../store/actions/authActions"
// import InviteLawyerForm from "../../components/Forms/InviteLawyerForm";

const Transition = (props) => {
    return <Slide direction="down" {...props} />
}

class Users extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataLoaded: false,
            assignActionModal: false,
            volUID: '',
            username: ''
        };
    }

    handleClickOpen = (modal, volUID) => {
        var x = [];
        x[modal] = true;
        this.setState({
            ...x,
            volUID
        });
    }

    handleClose = (modal) => {
        var x = [];
        x[modal] = false;
        this.setState(x);
    }

    loadData = () => {
        let data = this.props.users.dataRows.map((prop, key) => {
            let colObj = { ...prop }
            const volUID = colObj.volUID
            const username = colObj.username
            // Load Data for Summary Cards and add buttons     
            return {
                ...colObj,
                // status: (<span style={{ color: "red" }}>assigned</span>),
                id: key,
                actions: (
                    <Button
                        color="primary"
                        fullWidth
                        onClick={
                            () => this.handleClickOpen("assignActionModal",
                                volUID
                            )}
                    >ASSIGN ACTION</Button>)
            }
        })

        this.setState({
            data,
            dataLoaded: true
        })
    }

    handleChange = (docID) => {
        console.log(docID)
    }

    render() {
        const { AuthBool, classes, startLogout } = this.props;
        const searchButton =
            classes.top +
            " " +
            classes.searchButton;

        if (AuthBool) {
            if (this.props.users.dataLoaded
                && !this.state.dataLoaded) {
                this.loadData()
            }
        }

        return (
            <div>
            {
                this.state.dataLoaded ? (
                    <GridContainer justify="center" style={{ margin: "10px" }}>
                        <GridItem xs={12}>
                        <h2 style={{margin: "-10px 0px 20px 0px", fontSize: "20px", fontWeight: "600"}}>Invite Someone</h2>
                          <h2 style={{margin: "20px 0px 20px 0px", fontSize: "20px", fontWeight: "600"}}>Quick Links & Policies</h2>
                            <GridContainer style={{width: "94%"}}>
                            <GridItem xs={6} sm={6} md={6}>
                                <Link to="/profile">
                            <Button
                            color="primary"
                            style={{
                                width: "100%",
                                marginTop: "0px",
                                backgroundColor: "#0fb3d8",
                                marginBottom: "10px",
                                marginRight: "30px"
                            }}>
                            <FaceIcon/><b>Your profile</b>
                            </Button>
                            </Link>
                        </GridItem>
                        <br/>
                        <GridItem xs={6} sm={6} md={6}>
                        <Link to="/my-account/orders/">
                        <Button
                        color="primary"
                        style={{
                            width: "100%",
                            marginTop: "0px",
                            backgroundColor: "#0fb3d8",
                            marginBottom: "10px",
                            marginRight: "30px"
                        }}>
                        <AttachMoneyIcon/> <b>Billing Account</b>
                            </Button>
                            </Link>
                            </GridItem>
                            <br/>
                            <GridItem xs={6} sm={6} md={6}>
                            <Link to="/privacy-policy/" >
                            <Button
                        color="primary"
                        style={{
                            width: "100%",
                            marginTop: "0px",
                            backgroundColor: "#0fb3d8",
                            marginBottom: "10px",
                            marginRight: "30px"
                        }}>
                        <AssignmentIcon/> <b>Privacy</b>
                            </Button>
                            </Link>
                            </GridItem>
                            <br/>
                            <GridItem xs={6} sm={6} md={6}>
                            <a href="https://cloud.google.com/firestore/docs/server-side-encryption" target="_blank">
                            <Button
                        color="primary"
                        style={{
                            width: "100%",
                            marginTop: "0px",
                            backgroundColor: "#0fb3d8",
                            marginBottom: "10px",
                            marginRight: "30px"
                        }}>
                        <LockIcon/> <b>Security</b>
                            </Button>
                            </a>
                            </GridItem>
                            <br/>
                            <GridItem xs={6} sm={6} md={6}>
                            <Link to="/faq/" target="_blank">
                            <Button
                        color="primary"
                        style={{
                            width: "100%",
                            marginTop: "0px",
                            backgroundColor: "#0fb3d8",
                            marginBottom: "10px",
                            marginRight: "30px"
                        }}>
                        <CallIcon/>  <b>Help</b>
                            </Button>
                            </Link>
</GridItem>
                            <br/>
                            <GridItem xs={6} sm={6} md={6}>
                            <Link to="/about/" target="_blank">
                            <Button
                        color="primary"
                        style={{
                            width: "100%",
                            marginTop: "0px",
                            backgroundColor: "#0fb3d8",
                            marginBottom: "10px",
                            marginRight: "30px"
                        }}>
                        <InfoIcon/> <b>About CargoRx</b>
                            </Button>
                            </Link>
</GridItem>
                            <br/>
                            </GridContainer>
                            <h2 style={{margin: "20px 0px 20px 0px", fontSize: "20px", fontWeight: "600"}}>Account Settings</h2>
                            <GridContainer style={{ padding: "10px 10px 8px 10px", width: "87%", marginLeft: "0px", marginRight: "0px", backgroundColor: "#FFFFFF", borderRadius: "10px" }}>
                            <GridItem xs={10} sm={10} md={10}>
                                <p style={{marginTop: "15px"}}><b>Advertiser Account: </b></p>
                            </GridItem>
                            
                            <GridItem xs={2} sm={2} md={2}>
                                
                <div className={classes.block}>
                  <FormControlLabel 
                    control={
                      <Switch                             
                        checked={this.state.checkedA}
                        onChange={this.handleChange("checkedA")}
                        value="checkedA"
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                  />
                </div>                   
              </GridItem>
            </GridContainer>
                            <GridContainer style={{ padding: "10px 10px 8px 10px", marginTop: "20px", width: "87%", marginLeft: "0px", marginRight: "0px", backgroundColor: "#FFFFFF", borderRadius: "10px" }}>
                            <GridItem xs={10} sm={10} md={10}>
                                <p style={{marginTop: "15px"}}><b>Email Notifications: </b></p>
                            </GridItem>
                            
                            <GridItem xs={2} sm={2} md={2}>
                                
                <div className={classes.block}>
                  <FormControlLabel 
                    control={
                      <Switch                             
                        checked={this.state.checkedB}
                        onChange={this.handleChange("checkedB")}
                        value="checkedB"
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                  />
                </div>                   
              </GridItem>
            </GridContainer>
            <GridContainer style={{ padding: "10px 10px 8px 10px", width: "87%", marginTop: "20px", marginLeft: "0px", marginRight: "0px", backgroundColor: "#FFFFFF", borderRadius: "10px" }}>
                            <GridItem xs={10} sm={10} md={10}>
                                <p style={{marginTop: "15px"}}><b>Push Notifications: </b></p>
                            </GridItem>
                            
                            <GridItem xs={2} sm={2} md={2}>
                                
                <div className={classes.block}>
                  <FormControlLabel 
                    control={
                      <Switch                             
                        checked={this.state.checkedC}
                        onChange={this.handleChange("checkedC")}
                        value="checkedC"
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                  />
                </div>                   
              </GridItem>
            </GridContainer>
<GridContainer style={{width: "94%", marginTop: "20px"}}>
            <GridItem xs={6} sm={6} md={6}>
                            <Link to="/archived">
                            <Button
                        color="primary"
                        style={{
                            marginTop: "0px",
                            backgroundColor: "#0fb3d8",
                            marginBottom: "10px",
                            marginRight: "30px",
                            width: "100%"
                        }}>
                        <ArchiveIcon/> <b>Archived Orders</b>
                            </Button>
                            </Link>
                        </GridItem>
                            <GridItem xs={6} sm={6} md={6}>
                            <div className={classes.blueText}>
                                <div onClick={startLogout} style={{cursor: "pointer"}}>
                                    <Button
                                    color="primary"
                                    style={{
                                        marginTop: "0px",
                                        paddingBottom: "12px",
                                        width: "100%",
                                        backgroundColor: "#FC6047",
                                        marginBottom: "10px",
                                    }}>
                                    <b>Log Out</b>
                                    </Button>
                                </div>
                                {/* <p>Deactivate account</p>
                                <p>Delete account <b>(permanent)</b></p> */}
                            </div>
                            </GridItem>
                            </GridContainer>
                        </GridItem>
                        <div style={{margin:"45px"}}></div>
                    </GridContainer>

                ) : (
            <div style={{backgroundColor: "#F7F4F0", position: "absolute", width: "100%", height: "100%"}}>
                <img
                style={{margin: "65% 0% 0% 41%", position: "relative", width: "20%"}}
                src={loader}
                alt="..."
                />
          </div>                          )
            }
        </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        AuthBool: !!state.auth.user,
        users: state.admin.users
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        startLogout: () => dispatch(startLogout()),
        startSetUsersList: dispatch(startSetUsersList())
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(Style)
)(Users);



// WEBPACK FOOTER //
// ./src/views/Settings/Settings.jsx